export const API_BASE_URL = process.env.API_BASE_URL;
export const AI_PLANET_PROXY = process.env.AI_PLANET_PROXY;
export const AI_PLANET_PROXY_WSS = process.env.AI_PLANET_PROXY_WSS;

export const ACTIVITY_ANALYSER = API_BASE_URL;

export const ASSESSMENT_QUEUE_SERVICE = process.env.ASSESSMENT_QUEUE_SERVICE;

export const DICTIONARY_SERVICE = process.env.DICTIONARY_SERVICE;

export const CLOUDFRONT_URL = process.env.CLOUDFRONT_URL;

export const APPLICATION_NAME = "Intelliread";

export const FORCE_ENABLE_TEXT_TO_SPEECH = true;

export const paths = {
  home: "/",
  auth: {
    signIn: "/auth/sign-in",
    signUp: "/auth/sign-up",
    resetPassword: "/auth/reset-password",
  },
  dashboard: {
    overview: "/dashboard",
    account: "/dashboard/account",
    customers: "/dashboard/customers",
    integrations: "/dashboard/integrations",
    settings: "/dashboard/settings",
  },
  courses: {
    all: "/courses",
    create: "/courses/create",
    edit: "/courses/edit/:id",
  },

  questionBank: {
    all: "/question-bank",
    create: "/question-bank/create",
    edit: "/question-bank/edit/:id",
  },
  quiz: {
    all: "/quiz",
  },
  assessments: {
    all: "/assessments",
  },
  errors: { notFound: "/errors/not-found" },
};

export const json_files = {
  speechConfig: {
    name: "irSpeechConfig.json",
    url: `${CLOUDFRONT_URL}/configuration/irSpeechConfig.json`,
  },
  gradingModels: {
    name: "irGrading.json",
    url: `${CLOUDFRONT_URL}/configuration/irGrading.json`,
  },
  irLevels: {
    name: "ir-level-course-mapping.json",
    url: `${CLOUDFRONT_URL}/configuration/ir-level-course-mapping.json`,
  },
};
